import { config } from "@app-contexts/sdk/services/config";
import { Widget, WidgetQueryParams } from "@app-contexts/sdk/services/Widget";

// handlers are dependent on each other - checkout listener needs calendar
// and calendar needs checkout
// eslint-disable-next-line import/no-cycle
import {
  checkoutWidget,
  eventPurchaseWidget,
  expressCheckoutWidget,
} from "./checkout";

/**
 * Opens the calendar widget
 * @param venueId id of venue
 * @param params values to add to URL params (e.g. 'theme-primary', 'theme-secondary', etc.)
 * @param containerId id of the container to embed the widget in
 */
export async function calendarWidget(
  venueId: string,
  params: WidgetQueryParams,
  containerId?: string
) {
  const isAttraction = params?.is_attraction === true;
  const url = await config.calendarWidgetUrl(
    venueId,
    isAttraction,
    params?.event_id
  );
  const widget = new Widget({
    src: url,
    containerId,
    queryParams: params,
  });

  widget
    .show()
    .on("showpass.calendar.event-purchase", ({ slug, params }) => {
      eventPurchaseWidget(slug, params);
    })
    .on("showpass.calendar.checkout", () => {
      widget.close({ removeBodyClass: false, remount: false });
      checkoutWidget(params);
    })
    .on("showpass.event-purchase.express-checkout", () => {
      widget.close({ removeBodyClass: false, remount: false });
      expressCheckoutWidget(params);
    })
    .on("showpass.calendar.remount", () => {
      widget.remount();
    });

  return widget;
}

/**
 *  @deprecated use calendarWidget with the "containerId" query param set instead
 *  This function is only used in the v1 SDK
 */
export function mountCalendarWidget(id: string, params: WidgetQueryParams) {
  return calendarWidget(id, params, "showpass-calendar-widget");
}
